export class TranslationConfig {
  apiUrl: string;
}
